import React, {useState} from 'react';
import './App.scss';
import Education from './components/education/education';
// import Compare from './components/compare/compare';

// const radioBoxData = [
//   { value: 'education', label: 'Investment Migration Countries' },
//   { value: 'compare', label: 'Compare' },
// ];

const App = () => {

  // const [radioboxSelected, setRadioboxSelected] = useState(radioBoxData[0].value);
  // const [menuTitle, setMenuTitle] = useState(radioBoxData[0].label);
  // const [menuOpen, setMenuOpen] = useState(false);

  
  // const handleRadioboxChange = (event) =>{
  //   setRadioboxSelected(event.target.value);
  //   setMenuOpen(false);

  //   let selectedRadioData = radioBoxData.filter((item) => item.value === event.target.value);
  //   // console.log(selectedRadioData);
  //   setMenuTitle(selectedRadioData[0].label);
  // }

  // const handleMenuOpen = () =>{
  //   setMenuOpen(!menuOpen);
  // }

  // const componentsSwitch = (value) =>{
  //   switch (value) {
  //     case "education":
  //       return <Education />;
  //     case "compare":
  //       return <Compare />;
  //     default:
  //       return <Education />;
  //   }
  // }


  return (
    <div className="App">
      <div className="appContainer">
          {/* <div className={`mobileMenuWrapper mb-md-5 ${menuOpen ? "menuOpen": ""}`}>
            <button className="mobileMenuToggle" onClick={handleMenuOpen}>
              <div className="mobileMenuTitleText">{menuTitle}</div>

              <div className='dropdownIcon'>
                
                <svg width="14px" height="6px" viewBox="0 0 14 6">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-368.000000, -22.000000)" stroke="#405363">
                            <polyline points="381 22 375 28 369 22"></polyline>
                        </g>
                    </g>
                </svg>
              </div>
            </button>
            <div className="custom-radiobox-group" style={{'width': '100%', 'maxWidth': '740px'}}>
                  {radioBoxData.map((radioBox, index) => (
                    <label className="custom-radiobox" key={index}>
                      <input type="radio" value={radioBox.value} name="radio" checked={radioboxSelected === radioBox.value} onChange={handleRadioboxChange} /> 
                      <span className="label-text">{radioBox.label}</span>
                    </label>
                  ))}
            </div>
                
          </div> */}

          {/* {componentsSwitch(radioboxSelected)} */}
          
          <Education />

      </div>
      
    </div>
  );
}

export default App;
